export default __webpack_public_path__ + "static/media/Jiji.1d001804.jpg";